export const modalItems = {
  course: {
    name: 'course',
    action: { delete: 'Delete', withdraw: 'Withdraw' },
  },
  participant: {
    name: 'student',
    action: { kick: 'Kick' },
  },
  enrolment: {
    name: 'enrolment',
    action: { approve: 'Approve', reject: 'Reject' },
  },
  facePhoto: { name: 'photo', action: { delete: 'Delete' } },
  attendance: { name: 'attendance', action: { delete: 'Delete' } },
};
